import { IonContent, IonPage, isPlatform } from '@ionic/react';
import { Suspense, useEffect, useState } from 'react';
import { Route, useHistory, Redirect } from 'react-router-dom';

import TaroFooter from './components/navigation/footer/TaroFooter';
import Loader from './components/loader/Loader';

import { Keyboard } from '@capacitor/keyboard';

import { useUser } from './context/user-context';
import { useLazyLoad } from './hooks/useLazyLoad';

const AppRoutes = () => {
   const history = useHistory();
   const user = useUser();

   const WelcomePage = useLazyLoad('access/Access');
   const LandingPage = useLazyLoad('home/Home');
   const DetailPage = useLazyLoad('details/Details');
   const SupportPage = useLazyLoad('support/Support');
   const TicketPage = useLazyLoad('support/ticket/Ticket');
   const ProfilePage = useLazyLoad('profile/Profile');
   const DeviceInfoPage = useLazyLoad('device-info/DeviceInfo');

   const CheckAuth = (): boolean => {
      return !!user;
   };

   function GetRoot() {
      return CheckAuth() ? <LandingPage /> : <WelcomePage history={history} />;
   }

   const [showFooter, setShowFooter] = useState(true);

   useEffect(() => {
      if (Keyboard && isPlatform('android')) {
         Keyboard.addListener('keyboardWillShow', () => {
            setShowFooter(false);
         });
         Keyboard.addListener('keyboardWillHide', () => {
            setTimeout(() => {
               setShowFooter(true);
            }, 100);
         });
         return () => {
            Keyboard.removeAllListeners();
         };
      }
   }, []);

   return (
      <IonPage>
         <Suspense
            fallback={
               <IonContent scrollY={false}>
                  <Loader />
               </IonContent>
            }
         >
            <Route
               exact
               path='/'
               render={() => GetRoot()}
            ></Route>
            <Route
               exact
               path='/details/:deviceID'
               render={() => (CheckAuth() ? <DetailPage /> : <Redirect to='/' />)}
            ></Route>
            <Route
               exact
               path='/support'
               render={() => (CheckAuth() ? <SupportPage /> : <Redirect to='/' />)}
            />
            <Route
               exact
               path='/support/ticket/:deviceAlias?'
               render={() => (CheckAuth() ? <TicketPage /> : <Redirect to='/' />)}
            />
            <Route
               exact
               path='/profile'
               render={() => (CheckAuth() ? <ProfilePage /> : <Redirect to='/' />)}
            />
            <Route
               exact
               path='/device-info/:deviceID'
               render={() => (CheckAuth() ? <DeviceInfoPage /> : <Redirect to='/' />)}
            />
            <Route path='*'>
               <Redirect to='/' />
            </Route>
         </Suspense>
         {CheckAuth() && showFooter && <TaroFooter />}
      </IonPage>
   );
};

export default AppRoutes;
